import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex ml-4 flex-col" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "uppercase" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bg-dark-blue-400 bg-opacity-25 rounded-md text-xs ml-8 px-2 py-1" }, " Default ", -1)
const _hoisted_9 = {
  key: 1,
  class: "text-xl mb-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
	UiCard,
	UiButton,
	SvgIcon,
	UiLoader,
	useLoading,
	Tooltip,
	useConfirmation
} from '@/ui-kit';
import { usePaymentMethodsState } from '../use-payment-methods.state';
import { env } from '@/config';
import {
	onMounted,
	ref,
	nextTick
} from '@vue/runtime-core';
import { useCompanyProfileState } from '@/account/state/use-company-profile-state';
import AddPaymentMethodForm from '../components/AddPaymentMethodForm.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useToggle } from '@vueuse/shared';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethods',
  setup(__props) {

// import { cardTypes } from '@/payment-methods/views/CreditCard/card-types';
const state = usePaymentMethodsState();

const cardDiv = ref<HTMLDivElement>();

const { userProfile } = useCompanyProfileState();
const paymentMethodFormRef =
	ref<InstanceType<typeof AddPaymentMethodForm>>();

const { loading, toggleLoading } = useLoading();

async function create() {
	paymentMethodFormRef.value?.openDialog();
}

state.loadPaymentMethods(true);

const cardImageSrc = function (brand: string) {
	const cardTypes = [
		'visa',
		'mastercard',
		'dinners-club',
		'maestro',
		'jcb',
		'american-express',
		'discover'
	];
	const cardType = `${
		brand
			? cardTypes.find((type) => brand === type) ||
			  'default'
			: 'default'
	}.png`;
	return `/cards/${cardType}`;
};

const route = useRoute();

onMounted(async () => {
	if (route.params.openDialog || route.query.openDialog) {
		await nextTick();
		create();
	}
});

const { openConfirmation, closeConfirmation } =
	useConfirmation();
const [isLoading, setIsLoading] = useToggle();
const toast = useToast();

async function triggerRemovePaymentMethod(id: number) {
	const result = await openConfirmation(
		'Are you sure you want to remove this payment method',
		"You won't be able to use this payment method.",
		{
			isLoading: computed(() => isLoading.value)
		}
	);

	if (!result) {
		return;
	}

	setIsLoading(true);
	await state.deletePaymentMethod(id);
	closeConfirmation();
	toast.success('Payment method removed');
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_unref(UiCard), {
    title: "Payment methods",
    theme: "white",
    class: "relative pt-4 px-4 min-h-300"
  }, {
    default: _withCtx(() => [
      (!_unref(state).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(state).paymentMethods.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(state).paymentMethods, (method) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex items-center group cursor-pointer hover:bg-dark-blue-400 hover:bg-opacity-10 p-2 rounded-md transition group",
                    key: method.stripe_payment_id
                  }, [
                    _createElementVNode("img", {
                      class: "h-9",
                      src: 
								cardImageSrc(method.brand)
							
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(method.brand), 1),
                        _createTextVNode(" **** **** **** " + _toDisplayString(method.last4), 1)
                      ]),
                      _createElementVNode("div", _hoisted_6, " Expires " + _toDisplayString(method.exp_month) + "/" + _toDisplayString(method.exp_year), 1)
                    ]),
                    _createVNode(_unref(Tooltip), null, {
                      popper: _withCtx(() => [
                        _createTextVNode(" Remove payment method ")
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (
									triggerRemovePaymentMethod(
										method.id
									)
								),
                          class: "group-hover:opacity-100 opacity-0 pr-2 flex ml-5"
                        }, [
                          _createVNode(_unref(SvgIcon), {
                            class: "h-5 w-5 outline-none",
                            name: "close"
                          })
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024),
                    (method.is_primary)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          "show-after": 500,
                          "hide-after": 0,
                          content: "Future payments will use this payment method."
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("h1", _hoisted_9, [
                  _createTextVNode(" You have no payment methods. "),
                  _hoisted_10
                ])),
            _createElementVNode("div", null, [
              _createVNode(_unref(UiButton), {
                class: "!text-sm !h-10 !px-2",
                theme: "transparent",
                onClick: create,
                loading: _unref(loading)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(SvgIcon), {
                    class: "h-5 w-5 mr-2",
                    name: "only-plus"
                  }),
                  _createTextVNode("Add Payment Method ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]))
        : (_openBlock(), _createBlock(_unref(UiLoader), {
            key: 1,
            loadingText: "Loading payment methods...",
            wrapperClass: "base-darken text-reverse"
          })),
      _createVNode(AddPaymentMethodForm, {
        ref_key: "paymentMethodFormRef",
        ref: paymentMethodFormRef
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})